import { Input, Label, ErrorMessage } from '@iwoca/orion-ui';
import { Field } from 'redux-form';

export const FormField = (props) => <Field component={FormInput} {...props} />;

const FormInput = ({ input, placeholder, label, meta: { touched, error } }) => (
    <div className="my-l">
        <Label htmlFor={input.name}>{label}</Label>
        {/* eslint-disable-next-line iwoca/input-a11y */}
        <Input {...input} id={input.name} placeholder={placeholder} />
        {touched && error && (
            <ErrorMessage className="mt-s">
                <ErrorMessage.Icon />
                <ErrorMessage.Text data-testid="formErrors">
                    {error}
                </ErrorMessage.Text>
            </ErrorMessage>
        )}
    </div>
);
